import { Component, Inject, Injector, OnInit } from '@angular/core';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { ScheduleRegistrationSecretaryComponent } from '../registration/schedule-registration.component';

@Component({
  selector: 'page-schedule',
  templateUrl: './schedule-appointment.component.html',
  styleUrls: ['./schedule-appointment.component.scss'],
})
export class ScheduleAppointmentSecretaryComponent extends BaseComponent implements OnInit {
  public title = 'Agendar consulta';
  public search = '';
  public practitioners: practitionerI[] = [];

  public practitionerRole: any[] = [];

  public procedure: any = {};

  public get practitionersFilter(): practitionerI[] {
    const practitioners = [...this.practitioners];
    return practitioners.filter(
      (item: practitionerI) =>
        this.search == '' ||
        (item.name && item.name.indexOf(this.search) > -1) ||
        (item.specialty && item.specialty.indexOf(this.search) > -1) ||
        (item.address && item.address.city && item.address.city.indexOf(this.search) > -1)
    );
  }

  constructor(private practitionerService: PractitionerService, private healthcareService: ProcedureService, private injector: Injector) {
    super(injector);
  }

  async ngOnInit() {
    await this.getPractitioners();

    this.getPractitionerRole();
    this.getProcedures();
  }

  openComponentDialogScheduleRegistrationForm(practitioner: any) {
    const data = {
      title: 'Agendar consulta',
      param: { practitioner, type: 'Consulta', procedure: this.procedure },
    };

    this.dialog.openComponentDialog(ScheduleRegistrationSecretaryComponent, data);
  }

  openPractitionerLink() {
    this.dialog.openPractitionerLinkDialog({
      title: 'Vincular especialista',
      component: 'practitioner-link',
      param: {},
    });
  }

  transformToFormData(healthcareserviceData: any): any {
    return {
      healthcareservice_id: healthcareserviceData.healthcareservice_id,
      name: healthcareserviceData.name,
      description: healthcareserviceData.description,
      organization: {
        name: healthcareserviceData.providedBy.display,
        organization_id: healthcareserviceData.providedBy.code,
      },
      extraDetails: healthcareserviceData.extraDetails,
      type: healthcareserviceData?.type[0]?.coding[0]?.display,
      price_low: parseInt(healthcareserviceData?.valueRange?.low?.value),
      price_high: parseInt(healthcareserviceData?.valueRange?.high?.value),
      status: healthcareserviceData.status,
      specialty: healthcareserviceData.specialty[0].coding[0].display,
      comment: healthcareserviceData.comments,
      appointmentRequired: healthcareserviceData.appointmentRequired,
    };
  }

  // Trazer o procedure referente a atendimento
  getProcedures() {
    this.healthcareService.getProcedures().subscribe({
      next: (resHealthcare) => {
        this.procedure = this.transformToFormData(resHealthcare[0]);
      },
      error: (err) => {
        console.log('Falha ao buscar Healthcare');
      },
    });
  }

  async getPractitioners() {
    return this.practitionerService.list().subscribe({
      next: (resPractioner: any) => {
        this.practitioners = resPractioner;
      },
      error: (err) => {
        console.log('Falha ao buscar medicos', err);
      },
    });

    //@TODO GET practitioner
    //this.practitioners = this.auth.getFromLocalStorage('practitioners');
  }

  transformPractionerRoleToForm(dadosOriginais: any) {
    // Extrair os dados necessários
    const crm = dadosOriginais.identifier[0].value;
    const organization_name = dadosOriginais.organization.display;
    const organization_id = dadosOriginais.organization.references.split('/').pop();
    const practitioner_id = dadosOriginais.practitioner.references.split('/').pop();
    const practitioner_name = dadosOriginais.practitioner.display;
    const speciality = dadosOriginais.specialty;

    // Criar o novo objeto com a estrutura desejada
    const novoObjeto = {
      practitionerrole_id: dadosOriginais.practitionerrole_id,
      crm: crm,
      organization_name: organization_name,
      organization_id: organization_id,
      practitioner_id: practitioner_id,
      practitioner_name: practitioner_name,
      speciality: speciality,
    };

    return novoObjeto;
  }

  getPractitionerRole() {
    const practitionerRolemOck = [
      {
        practitionerrole_id: '82b55c61-778e-4860-92b2-ac796de3b8db',
        active: true,
        identifier: [
          {
            system: 'CRM',
            value: '56789',
          },
        ],
        organization: {
          display: 'Ritmo Cor',
          references: 'organization/123445',
        },
        practitioner: {
          display: 'Dr Ailton',
          references: 'practitioner/c86b2339-41da-4e91-9ddd-c0edee6a5911',
        },
        specialty: 'Neurologia',
        telecom: '',
      },
    ];

    this.practitionerRole = practitionerRolemOck.map((item) => this.transformPractionerRoleToForm(item));
  }

  getRole(practitioner: any) {
    return this.practitionerRole.find((registro) => registro.practitioner_id == 'c86b2339-41da-4e91-9ddd-c0edee6a5911');
  }

  getSpecialization(practitioner: any) {
    return 'Cardiologista';

    const role = this.getRole(practitioner);

    if (!role) return '';
    return role.speciality;
  }

  getPrefix(practitioner: practitionerI) {
    if (practitioner.gender) {
      return practitioner.gender == 'Female' ? 'Dra. ' : 'Dr. ';
    }
    return '';
  }

  getCity(practitioner: practitionerI) {
    if (practitioner.address && (practitioner.address.city || practitioner.address.state)) {
      return `${practitioner.address.city}/${practitioner.address.state}`;
    }
    return '';
  }
}
